import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allCustomerAssets: [{}],
  allCustomerContracts: [{}],
  allContractsWithSiteIDS: [{}],
  assetsFromCustomerContract: [{}],
  createdContract: {},
  updatedContract: {},
  deletedContract: {},
  createdAsset: {},
  updatedAsset: {},
  deletedAsset: {},
  error: null,
};

const assetManagementSlice = createSlice({
  name: 'assetManagement',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setAllCustomerAssets: (state, action) => {
      state.allCustomerAssets = action.payload;
      state.error = null;
    },
    setAllCustomerContracts: (state, action) => {
      state.allCustomerContracts = action.payload;
      state.error = null;
    },
    setAssetsFromCustomerContract: (state, action) => {
      state.assetsFromCustomerContract = action.payload;
      state.error = null;
    },
    setCreatedContract: (state, action) => {
      state.createdContract = action.payload;
      state.error = null;
    },
    setUpdatedContract: (state, action) => {
      state.updatedContract = action.payload;
      state.error = null;
    },
    setDeletedContract: (state, action) => {
      state.deletedContract = action.payload;
      state.error = null;
    },
    setCreatedAsset: (state, action) => {
      state.createdAsset = action.payload;
      state.error = null;
    },
    setUpdatedAsset: (state, action) => {
      state.updatedAsset = action.payload;
      state.error = null;
    },
    setDeletedAsset: (state, action) => {
      state.deletedAsset = action.payload;
      state.error = null;
    },
    setResetAssetManagement: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllCustomerAssets,
  setAllCustomerContracts,
  setAssetsFromCustomerContract,
  setCreatedContract,
  setUpdatedContract,
  setDeletedContract,
  setCreatedAsset,
  setUpdatedAsset,
  setDeletedAsset,
  setResetAssetManagement,
} = assetManagementSlice.actions;

export default assetManagementSlice.reducer;
